import React from 'react'
import { Helmet } from 'react-helmet-async'
import AWSManagedLayout from '../../layouts/Billing/AWSManagedLayout'

const AWSManagedSubscriptionPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Billing Details</title>
      <meta name="description" content="Billing Details" />
    </Helmet>
    <AWSManagedLayout />
  </React.Fragment>
)

export default AWSManagedSubscriptionPage
